import Grid from "@mui/material/Grid/Grid";
import Paper from "@mui/material/Paper/Paper";
import {CustomLabelRegularMedium, CustomLabelSmallMedium, 
    // CustomLabelXSmallRegular
} from "../common/CustomLabel";
import XMARK from "../../assets/images/xmark.png";
import LOGO_SMALL from "../../assets/images/logo-small.png";
import BOX_ICON from "../../assets/images/3d-center-box.png";
import SIDE_BAR from "../../assets/images/sidebar-collapse.png";
import Box from "@mui/material/Box/Box";
import LOGO_WITH_TEXT from "../../assets/images/logo-with-text.png";
import MAIL_ICON from "../../assets/images/mail.png";
import OSTRYX_LOGO from "../../assets/svgs/ostryx.svg";
import React from "react";
// import React, { useState, useEffect, useMemo } from "react";

import {useLocation, useNavigate, 
    // Outlet, 
    Link as RouterLink} from "react-router-dom"
import Link from "@mui/material/Link/Link";

const NavBar = ({isMenuClicked, serviceRef, portfolioRef, testimonalsRef, partnersRef, setIsMenuClicked, setShowWhatService, contactUsRef,trustedByIndustryLeadersRef, className}) => {

    let navigate = useNavigate();
    const location = useLocation();
    const isHomePage = location.pathname === "/";

    // const onClickLogo = (e) => {
    //     navigate('/');
    //     setIsMenuClicked(false);
    // }


    // const onClickService = (e) => {
    //     navigate('/services');

    //     // const currentPath = window.location.pathname;
    
    //     // if (currentPath === "/") {
    //     //     e.preventDefault();
    //     //     if (serviceRef && serviceRef.current) {
    //     //         serviceRef.current.scrollIntoView({ behavior: 'smooth' });
    //     //     }
    //     // } else {
    //     //     navigate('/services');
    //     //     // navigate('/');
    //     //     // Optional: Add a callback to scroll after navigation
    //     //     setTimeout(() => {
    //     //         if (serviceRef && serviceRef.current) {
    //     //             serviceRef.current.scrollIntoView({ behavior: 'smooth' });
    //     //         }
    //     //     }, 100);
    //     setIsMenuClicked(false);
    // }


    // const onClickPortfolio = (e) => {
    //     const currentPath = window.location.pathname;
    
    //     if (currentPath === "/") {
    //         e.preventDefault();
    //         if (portfolioRef && portfolioRef.current) {
    //             portfolioRef.current.scrollIntoView({ behavior: 'smooth' });
    //         }
    //     } else {
    //         // navigate('/our-work');
    //         navigate('/');
    //     }
    //     setIsMenuClicked(false);
    // }


    // const onClickAboutUs = (e) => {
    //     navigate('/about-us');
    // }
    // const onClickHome = (e) => {
    //     navigate('/');
    // }


    // const onClickTestimonials = (e) => {
    //     const currentPath = window.location.pathname;
    
    //     if (currentPath === "/") {
    //         e.preventDefault();
    //         if (testimonalsRef && testimonalsRef.current) {
    //             testimonalsRef.current.scrollIntoView({ behavior: 'smooth' });
    //         }
    //     } else {
    //         navigate('/');
    //         // navigate('/testimonials');
    //     }
    //     setIsMenuClicked(false);
    // }


    // const onClickPartners = (e) => {
    //     const currentPath = window.location.pathname;
    
    //     if (currentPath === "/") {
    //     e.preventDefault();
    //     if (trustedByIndustryLeadersRef && trustedByIndustryLeadersRef.current) {
    //         trustedByIndustryLeadersRef.current.scrollIntoView({ behavior: 'smooth' });
    //         }
    //     } else {
    //         navigate('/');
    //     }
    //     setIsMenuClicked(false);
    // }


    // const onClickBlogs = (e) => {
    //     navigate('/blogs');
    // }


    const closeMenu = (e) => {
        setIsMenuClicked(false);
    }


    const onClickWhatService = () => {
        setShowWhatService(true)
    }


    const openMenu = (e) => {
        setIsMenuClicked(true);
    }


    // const onClickContactUs = (e) => {
    //     navigate('/contact-us');
    // }

    return (
        <>
            <Box sx={{ 
                height: { xs: '72px', md: '72px' },
                width: '100%'
            }} />

            <Grid item xs={12} container sx={{
                display: {xs: isMenuClicked ? 'flex' : 'none', md: 'none'},
                padding: "20px 0px",
                position: "fixed",
                borderRadius: "0px 0px 60px 60px",
                top: 0,
                zIndex: 100,
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                border: "1px solid #DDDDDD"
            }}
                  justifyContent={"center"}
                  direction={"row"}>
                <Grid item container xs={8} sx={{marginTop: "60px"}}>
                    <Link onClick={() => navigate('/')} style={{ textDecoration: 'none', width: '100%' }}>
                        <Paper sx={{
                            width: "100%",
                            padding: "20px 0px",
                            cursor: "pointer",
                            borderRadius: "25px",
                            border: "1px solid #DDDDDD"
                        }}>
                            <CustomLabelRegularMedium color={"#5E17EB"} sx={{ width: "100%", textAlign: "center" }}>
                                Home
                            </CustomLabelRegularMedium>
                        </Paper>
                    </Link>
                </Grid>
                <Grid item container xs={8} sx={{marginTop: "10px"}}>
                    <Link onClick={() => navigate('/services')} style={{ textDecoration: 'none', width: '100%' }}>
                        <Paper sx={{
                            width: "100%",
                            padding: "20px 0px",
                            cursor: "pointer",
                            borderRadius: "25px",
                            border: "1px solid #DDDDDD"
                        }}>
                        <CustomLabelRegularMedium color={"#5E17EB"}>
                            Services
                            </CustomLabelRegularMedium>
                        </Paper>
                    </Link>
                </Grid>
                <Grid item container xs={8} sx={{marginTop: "10px"}}>
                    <Link onClick={() => navigate('/about-us')} style={{ textDecoration: 'none', width: '100%' }}>
                        <Paper sx={{
                            width: "100%",
                            padding: "20px 0px",
                            cursor: "pointer",
                            borderRadius: "25px",
                            border: "1px solid #DDDDDD"
                        }}>
                            <CustomLabelRegularMedium color={"#5E17EB"}>
                                About Us
                            </CustomLabelRegularMedium>
                        </Paper>
                    </Link>
                </Grid>
                {/* <Grid item container xs={8} sx={{marginTop: "10px"}}>
                    <Paper sx={{
                        width: "100%",
                        padding: "20px 0px",
                        cursor: "pointer",
                        borderRadius: "25px",
                        border: "1px solid #DDDDDD"
                    }} onClick={onClickBlogs}>
                        <CustomLabelRegularMedium text={"Blogs"} color={"#5E17EB"}/>
                    </Paper>
                </Grid> */}
                {isHomePage && (
                    <>
                        {/* <Grid item container xs={8} sx={{marginTop: "10px"}}>
                            <Paper sx={{
                                width: "100%",
                                padding: "20px 0px",
                                borderRadius: "25px",
                                cursor: "pointer",
                                border: "1px solid #DDDDDD"
                            }} onClick={onClickPortfolio}>
                                <CustomLabelRegularMedium color={"#5E17EB"}>
                                    Portfolio
                                </CustomLabelRegularMedium>
                            </Paper>
                        </Grid>

                        <Grid item container xs={8} sx={{marginTop: "10px"}}>
                            <Paper sx={{
                                width: "100%",
                                padding: "20px 0px",
                                borderRadius: "25px",
                                cursor: "pointer",
                                border: "1px solid #DDDDDD"
                            }} onClick={onClickTestimonials}>
                                <CustomLabelRegularMedium color={"#5E17EB"}>
                                    Testimonials
                                </CustomLabelRegularMedium>
                            </Paper>
                        </Grid>

                        <Grid item container xs={8} sx={{marginTop: "10px"}}>
                            <Paper sx={{
                                width: "100%",
                                padding: "20px 0px",
                                borderRadius: "25px",
                                cursor: "pointer",
                                border: "1px solid #DDDDDD"
                            }} onClick={onClickPartners}>
                                <CustomLabelRegularMedium color={"#5E17EB"}>
                                    Clients
                                </CustomLabelRegularMedium>
                            </Paper>
                        </Grid> */}
                    </>
                )}
                <Grid item container justifyContent={"center"} style={{marginTop: "60px", marginBottom: "20px"}}>
                    <Grid item container
                          style={{
                              border: "1.5px solid #DDDDDD",
                              background: "white",
                              borderRadius: 16,
                              padding: "10px",
                              width: "56px",
                              height: "56px",
                              cursor: "pointer"
                          }}
                          alignItems={"center"}
                          justifyContent={"center"}
                          onClick={closeMenu}
                    >
                        <Grid item>
                            <img src={XMARK} alt={"Close Menu"}/>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container
                  className={className}

                  sx={{
                      padding: {xs: "10px", md: "12px 20px"},
                      borderWidth: "1px 0px",
                      borderStyle: "solid",
                      borderColor: "#F5F5F5",
                      zIndex: 100,
                      display: {xs: 'flex', md: 'none'},
                      backdropFilter: 'blur(8px)',
                      WebkitBackdropFilter: 'blur(8px)',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      border: "1px solid #DDDDDD",
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      width: "100%"
                  }}
                  justifyContent={"space-between"} alignItems={"center"}>

                <Grid item>
                    <img alt={'OSTRYX'} src={LOGO_SMALL}/>
                </Grid>


                <Grid item>
                    <Grid container alignItems={"center"} style={{height: "100%"}}>


                        <Grid item style={{marginLeft: "0px"}}>
                            <Grid container style={{
                                border: "1.5px solid #F5F5F5",
                                borderRadius: 15,
                                padding: "12px 25px",
                                background: "#5E17EB",
                                cursor: "pointer"
                            }}
                                  alignItems={"center"}
                                  onClick={onClickWhatService}
                            >
                                <Grid item>
                                    <img src={BOX_ICON} alt={"Discuss Your Project"}/>
                                </Grid>
                                <Grid item style={{marginLeft: "10px"}}>
                                    <CustomLabelSmallMedium text={"Discuss Your Project"} color={"white"}/>
                                </Grid>
                            </Grid>
                        </Grid>


                        <Grid item style={{marginLeft: "5px"}} onClick={openMenu}>
                            <Grid container
                                  style={{
                                      border: "1.5px solid #DDDDDD",
                                      background: "#F5F5F5",
                                      borderRadius: 16,
                                      padding: "10px",
                                      cursor: "pointer"
                                  }}
                                  alignItems={"center"}>
                                <Grid item>
                                    <img src={SIDE_BAR} alt={"Side Bar"}/>
                                </Grid>
                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>
            </Grid>

            <Grid container
                  sx={{
                      display: {xs: 'none', md: 'flex'}, 
                      padding: {md: "12px 60px", lg: "12px 80px"}, 
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      borderWidth: "1px 0px",
                      borderStyle: "solid",
                      borderColor: "#F5F5F5",
                      zIndex: 100,
                      transition: 'all 0.3s ease',
                      boxShadow: '0px 4px 4px rgba(94, 23, 235, 0.1)',
                      backdropFilter: 'blur(8px)',
                      WebkitBackdropFilter: 'blur(8px)',
                  }}
                  className={className}
                  justifyContent={"space-between"} 
                  alignItems={"center"}>

                <Grid item onClick={() => navigate('/')} sx={{cursor: "pointer"}}>
                    {/* <Box component={"img"} alt={'OSTRYX'} src={LOGO_WITH_TEXT}
                         sx={{width: {md: "180px", lg: "212px"}}}
                         /> */}
                    <img alt={'OSTRYX'}  src={OSTRYX_LOGO}
                         sx={{width: {md: "180px", lg: "212px"}}}
                    />
                </Grid>


                <Grid item>
                    <Grid container alignItems={"center"} style={{height: "100%"}}>
                        <Grid item style={{cursor: "pointer"}}>
                            <CustomLabelSmallMedium>
                                <Link className={"plain-link"} onClick={() => navigate('/')} sx={{ cursor: 'pointer' }}>
                                    Home
                                </Link>
                            </CustomLabelSmallMedium>
                        </Grid>
                        <Grid item sx={{marginLeft: {md: "15px", lg: "20px", cursor: "pointer"}}}>
                            <CustomLabelSmallMedium>
                                <Link className={"plain-link"} onClick={() => navigate('/services')} sx={{ cursor: 'pointer' }}>
                                    Services
                                </Link>
                            </CustomLabelSmallMedium>
                        </Grid>
                        <Grid item  sx={{marginLeft: {md: "15px", lg: "20px", cursor: "pointer"}}}>
                            <CustomLabelSmallMedium>
                                <Link className={"plain-link"} onClick={() => navigate('/about-us')} sx={{ cursor: 'pointer' }}>
                                    About Us
                                </Link>
                            </CustomLabelSmallMedium>
                        </Grid>
                        {/* <Grid item sx={{marginLeft: {md: "15px", lg: "20px", cursor: "pointer"}}}
                              onClick={onClickBlogs}>
                            <CustomLabelSmallMedium text={"Blogs"}/>
                        </Grid> */}
                        {isHomePage && (
                            <>
                                {/* <Grid item sx={{marginLeft: {md: "15px", lg: "20px", cursor: "pointer"}}}>
                                    <CustomLabelSmallMedium>
                                        <Link className={"plain-link"} onClick={onClickPortfolio} sx={{ cursor: 'pointer' }}>
                                            Portfolio
                                        </Link>
                                    </CustomLabelSmallMedium>
                                </Grid>
                                <Grid item sx={{marginLeft: {md: "15px", lg: "20px", cursor: "pointer"}}}
                                    onClick={onClickTestimonials}>
                                    <CustomLabelSmallMedium text={"Testimonials"}/>
                                </Grid>
                                <Grid item sx={{marginLeft: {md: "15px", lg: "20px", cursor: "pointer"}}}
                                    onClick={onClickPartners}>
                                    <CustomLabelSmallMedium text={"Clients"}/>
                                </Grid> */}
                            </>
                        )}


                        <Grid item sx={{marginLeft: {md: "15px", lg: "20px"}}}>
                            <Link component={RouterLink} to="/contact-us" className={"plain-link"}>
                                <Grid container
                                    style={{
                                        border: "1.5px solid #F5F5F5",
                                        borderRadius: 15,
                                        padding: "12px 25px",
                                        cursor: "pointer"
                                    }}
                                    alignItems={"center"}
                                    sx={{
                                        backgroundColor: "white",
                                    }}
                                    // sx={{
                                    //     '&:hover': {
                                    //         backgroundColor: '#5E17EB',
                                    //         borderColor: '#5E17EB',
                                    //         transform: 'translateY(-2px)',
                                    //         boxShadow: '0 4px 8px rgba(94, 23, 235, 0.2)',
                                    //         '& .MuiTypography-root': {  // This targets the Typography component inside CustomLabelSmallMedium
                                    //             color: 'white !important'
                                    //         },
                                    //         '& .MuiGrid-item img': {  // This targets the Typography component inside CustomLabelSmallMedium
                                    //             filter: 'brightness(0) invert(1)'
                                    //         }
                                    //     }
                                    // }}
                                >
                                    <Grid item>
                                        <img src={MAIL_ICON} alt={"Mail Icon"}/>
                                    </Grid>
                                    <Grid item style={{marginLeft: "10px"}}>
                                        <CustomLabelSmallMedium color={"#5E17EB"}>
                                                Contact Us
                                        </CustomLabelSmallMedium>
                                    </Grid>
                                </Grid>
                            </Link>
                        </Grid>

                        <Grid item sx={{marginLeft: {md: "10px", lg: "20px"}}}>
                            <Grid container style={{
                                border: "1.5px solid #F5F5F5",
                                borderRadius: 15,
                                padding: "12px 25px",
                                background: "#5E17EB",
                                cursor: "pointer"
                            }}
                                  alignItems={"center"}
                                  onClick={onClickWhatService}

                            >
                                <Grid item>
                                    <img src={BOX_ICON} alt={"Discuss Your Project"}/>
                                </Grid>
                                <Grid item style={{marginLeft: "10px"}}>
                                    <CustomLabelSmallMedium text={"Discuss Your Project"} color={"white"}/>
                                </Grid>
                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>


            </Grid>
        </>
    )
}

export default NavBar;
